// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2-rit","label":"Radio_label__SBggW","checkMark":"Radio_checkMark__sQsyv","disabled":"Radio_disabled__pm5XF"};